import React from "react";
// mui 5
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
// react-router
import { useNavigate } from "react-router-dom";
// custom components
import PokemonCardCart from "../PokemonCardCart";
// custom context
import { useCart } from "../../context/CartContext";
// custom routes
import { CHECKOUT } from "../../utils/routes";
import {StyledCartSummary, 
  StyledCartActions,
  StyledCartItems,
  StyledFilledCart,
} from "./styledComponents";

function FilledCart() {
  const { cart, onEmptyCart } = useCart();
  const navigate = useNavigate();
  return (
    <StyledFilledCart>
      <StyledCartItems>
        <Grid container spacing={3}>
          {cart.items.map((item) => (
            <Grid item xs={12} sm={6} md={4} key={item.id}>
              <PokemonCardCart pokemon={item} />
            </Grid>
          ))}
        </Grid>
      </StyledCartItems>
      <StyledCartSummary>
        <Typography variant="h4">
          Subtotal: {`$${cart.subtotal.toFixed(2)}`}
        </Typography>
        <StyledCartActions>
          <Button
            size="medium"
            variant="contained"
            color="secondary"
            sx={{
              minWidth: "150px",
              mb: { xs: 1, sm: 0 },
              mr: { xs: 0, sm: 4 },
            }}
            onClick={onEmptyCart}
          >
            Empty Cart
          </Button>
          <Button
            size="medium"
            variant="contained"
            color="primary"
            sx={{ minWidth: "150px" }}
            onClick={() => navigate(CHECKOUT)}
          >
            Checkout
          </Button>
        </StyledCartActions>
      </StyledCartSummary>
    </StyledFilledCart>
  );
}

export default FilledCart;
